import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Footer from "../components/footers/LandingFooter";

interface LandingLayoutProps {
  children: React.ReactNode;
  disableAnimation?: boolean;
}

const LandingLayout: React.FC<LandingLayoutProps> = ({
  children,
  disableAnimation = false,
}) => (
  <AnimationRevealPage disabled={disableAnimation}>
    {children}
    <Footer />
  </AnimationRevealPage>
);

export default LandingLayout;
